import cx from 'classnames';
import * as React from 'react';

interface SeparatorProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

export function Separator({ className, ...props }: SeparatorProps) {
  return (
    <div className={cx('h-px w-full bg-gray-200', className)} {...props} />
  );
}
